import { SxProps, Theme } from '@mui/material'

/** Tick mark color for visx axes — matches label secondary styling. */
export const getFinancialChartTickStroke = (theme: Theme): string => theme.palette.text.secondary

export const financialSectionTitleSx: SxProps<Theme> = {
    fontSize: '1.125rem',
    lineHeight: 1.57,
}

export const financialSectionTitleMediumSx: SxProps<Theme> = {
    ...financialSectionTitleSx,
    fontWeight: 500,
}

export const financialSectionDescriptionSx: SxProps<Theme> = {
    display: 'block',
    mt: 0.01,
    mb: 1.8,
    color: 'text.secondary',
    fontSize: '0.875rem',
    lineHeight: 1.66,
}

export const financialSectionBlockSx: SxProps<Theme> = {
    mt: 3.75,
    width: '100%',
}

export const financialSectionContentSpacingSx: SxProps<Theme> = {
    mb: 1.05,
}

export const financialKeyFactLabelSx: SxProps<Theme> = {
    color: 'text.secondary',
    fontSize: 11,
    lineHeight: 1.3,
    textTransform: 'none',
}

export const financialKeyFactValueSx: SxProps<Theme> = {
    fontSize: '16px',
    lineHeight: 1.35,
    '& .MuiTypography-root': {
        fontSize: '16px',
        lineHeight: 1.35,
    },
    '& span': {
        fontSize: '16px',
        lineHeight: 1.35,
    },
}

export const financialChartPanelTitleSx: SxProps<Theme> = {
    fontWeight: 500,
    fontSize: '0.875rem',
    lineHeight: 1.25,
}

export const dualChartRowSx: SxProps<Theme> = {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'stretch',
    gap: 2,
    width: '100%',
}

export const dualChartPanelSx: SxProps<Theme> = {
    flex: '1 1 400px',
    minWidth: 0,
    maxWidth: '100%',
}

export const STATEMENT_CHART_PANEL_MIN_HEIGHT = 328
